export default __webpack_public_path__ + "static/leaderboard-placeholder-867fec397c9bb3eab5b696b7cd69d8b9.webp";